import locales, { ptBR } from '~/options/general/locales';
import { store } from '~/stores';

const getLocale = () => locales.find(item => item.id === store.getState().settings.locale) || ptBR;

export default getLocale;
